var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinflux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6452 14.3015L11.5784 19.4226L8.75848 16.5725L13.8253 11.4514L11.5719 9.17383L4.22705 16.5971L11.5516 23.9999L18.8963 16.5766L16.6452 14.3015Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 9.67258L11.5968 0L2 9.69962L2.0306 14.2333L11.5561 4.60602L21.1508 14.3037L21.1667 9.67258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinflux);
export default __webpack_public_path__ + "static/media/coinflux.5aa47c16d8c185dca5ecb273477b476d.svg";
export { ForwardRef as ReactComponent };